(function () {
  const MOBILE_QUERY = window.matchMedia('(max-width: 749px)');

  function getActiveIndex(slider, slides) {
    const scrollLeft = slider.scrollLeft;
    let closest = 0;
    let minDistance = Infinity;

    slides.forEach((slide, index) => {
      const distance = Math.abs(slide.offsetLeft - scrollLeft);
      if (distance < minDistance) {
        minDistance = distance;
        closest = index;
      }
    });

    return closest;
  }

  function setActiveDot(dots, index) {
    dots.forEach((dot, dotIndex) => {
      const isActive = dotIndex === index;
      dot.classList.toggle('slider-counter__link--active', isActive);
      if (isActive) {
        dot.setAttribute('aria-current', 'true');
      } else {
        dot.removeAttribute('aria-current');
      }
    });
  }

  function initBenefitsCarousel(section) {
    const slider = section.querySelector('[id^="Slider-"]');
    const dots = Array.from(section.querySelectorAll('[data-qeviq-pb-dot]'));
    if (!slider || dots.length === 0) return;

    const slides = Array.from(slider.querySelectorAll('.slider__slide'));
    if (slides.length === 0) return;

    let scrollTimer;

    const syncDots = () => {
      if (!MOBILE_QUERY.matches) return;
      setActiveDot(dots, getActiveIndex(slider, slides));
    };

    slider.addEventListener(
      'scroll',
      () => {
        window.clearTimeout(scrollTimer);
        scrollTimer = window.setTimeout(syncDots, 60);
      },
      { passive: true }
    );

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        if (!MOBILE_QUERY.matches) return;

        const index = parseInt(dot.dataset.qeviqPbDot, 10) || 0;
        const slide = slides[index];
        if (!slide) return;

        slider.scrollTo({
          left: slide.offsetLeft,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        });
        setActiveDot(dots, index);
      });
    });

    MOBILE_QUERY.addEventListener('change', syncDots);
    syncDots();
  }

  function initAll() {
    document.querySelectorAll('.multicolumn--qeviq-product-benefits').forEach(initBenefitsCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
